module.exports = __webpack_public_path__ + "img/VillaLoreto_Hotel.a74419c4.jpg";